import { render, staticRenderFns } from "./ForgotToAddCartMenuBlock.vue?vue&type=template&id=7337b822&scoped=true"
import script from "./ForgotToAddCartMenuBlock.vue?vue&type=script&lang=js"
export * from "./ForgotToAddCartMenuBlock.vue?vue&type=script&lang=js"
import style0 from "./ForgotToAddCartMenuBlock.vue?vue&type=style&index=0&id=7337b822&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7337b822",
  null
  
)

export default component.exports